import React, { memo, useEffect } from "react";
import styles from "./ProductDetailsForm.module.scss";
import FirstStepOfProductDetails from "./steps/FirstStepOfProductDetails";
import SecondStepOfProductDetails from "./steps/SecondStepOfProductDetails";
import ThirdStepOfCreateProduct from "./steps/ThirdStepOfProductDetails";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../stores/store";
import { moveToPreviousStep } from "../../../../stores/slices/solar-product-details-slice";
import { useLazyGetProductCategoriesQuery } from "../../../../service/category-service";
import { toast } from "react-toastify";

type Props = {};

const ProductDetailsForm: React.FC<Props> = memo((props: Props) => {
	const step = useSelector((state: RootState) => state.solarProductDetails.currentStep);
	const editingProductId = useSelector((state: RootState) => state.solarProductDetails.editingProductId);
	const [getCategories, { data, isLoading }] = useLazyGetProductCategoriesQuery();

	useEffect(() => {
		getCategories()
			.unwrap()
			.catch(err => toast.error(err?.data?.title as string));
	}, []);

	const dispatch = useDispatch();

	const back = () => {
		dispatch(moveToPreviousStep());
	};

	return (
		<>
			<div className={styles.headerContainer}>
				{step > 1 && (
					<button className={`standardButton ${styles.button} ${styles.backButton}`} onClick={back}>
						<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M3.52067 7.83342H12.8332C13.0693 7.83342 13.2672 7.75356 13.4269 7.59384C13.5866 7.43412 13.6665 7.2362 13.6665 7.00009C13.6665 6.76398 13.5866 6.56606 13.4269 6.40634C13.2672 6.24662 13.0693 6.16676 12.8332 6.16676H3.52067L7.604 2.08342C7.77067 1.91676 7.85053 1.72231 7.84359 1.50009C7.83664 1.27787 7.74984 1.08342 7.58317 0.916758C7.4165 0.76398 7.22206 0.684119 6.99984 0.677174C6.77762 0.67023 6.58317 0.750091 6.4165 0.916758L0.916504 6.41676C0.833171 6.50009 0.774143 6.59037 0.739421 6.68759C0.704699 6.78481 0.687338 6.88898 0.687338 7.00009C0.687338 7.1112 0.704699 7.21537 0.739421 7.31259C0.774143 7.40981 0.833171 7.50009 0.916504 7.58342L6.4165 13.0834C6.56928 13.2362 6.76025 13.3126 6.98942 13.3126C7.21859 13.3126 7.4165 13.2362 7.58317 13.0834C7.74984 12.9168 7.83317 12.7188 7.83317 12.4897C7.83317 12.2605 7.74984 12.0626 7.58317 11.8959L3.52067 7.83342Z"
								fill="#1C1B1F"
							/>
						</svg>
					</button>
				)}
				<h1>{editingProductId ? "Edit Product" : "Create Product"}</h1>
			</div>
			<div className={styles.formContainer}>
				<div style={{ display: step === 1 ? "block" : "none" }}>
					<FirstStepOfProductDetails  fetchingCategories={isLoading} categories={data?.categories || []} key={1} />
				</div>
				<div style={{ display: step === 2 ? "block" : "none" }}>
					<SecondStepOfProductDetails key={2} />
				</div>
				<div style={{ display: step === 3 ? "block" : "none" }}>
					<ThirdStepOfCreateProduct key={3} />
				</div>
			</div>
		</>
	);
});

export default ProductDetailsForm;
